import { ExpectedResponseType } from './types';
import { ResponseValueType } from '@onegov/react-component-library';

export const createMinValidator = (min?: number) => (value: number) =>
  typeof min === 'number' && value < min ? `The value cannot be less than ${min}` : undefined;

export const createMaxValidator = (max?: number) => (value: number) =>
  typeof max === 'number' && value > max ? `The value cannot be greater than ${max}` : undefined;

export const createMaxLengthValidator = (maxLength?: number) => (value: string) =>
  typeof maxLength === 'number' && maxLength != 0 && value?.length > maxLength ? `Response cannot exceed ${maxLength} characters` : undefined;

export const createRequiredValidator = (responseType: ExpectedResponseType, optional?: boolean) =>
  (value: ResponseValueType | ResponseValueType[] | null) => {
    if (optional) return undefined;

    if (value != null) {
      const hasValue =
        (typeof value === 'boolean') ||
        (typeof value === 'number' && value > 0) ||
        (typeof value === 'string' && value.trim().length > 0) ||
        (Array.isArray(value) && value.length >  0);

      if (hasValue) return undefined;
    }

    switch (responseType) {
      case ExpectedResponseType.Array:
      case ExpectedResponseType.Boolean:
      case ExpectedResponseType.Range:
        return 'You must select an option.';

      case ExpectedResponseType.Number:
        return 'You must enter a number.';

      case ExpectedResponseType.TextShort:
      case ExpectedResponseType.TextMedium:
      case ExpectedResponseType.TextLong:
      default:
        return 'You must enter a response.';
    }
  }